import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-success-dialog',
  //standalone: true,
  //imports: [],
  templateUrl: './success-dialog.component.html',
  styleUrl: './success-dialog.component.scss'
})
export class SuccessDialogComponent {

  mensaje = ''

  constructor( 
      @Inject(MAT_DIALOG_DATA) 
      public data: {mensaje: string}, 
      public dialogRef: MatDialogRef<SuccessDialogComponent>) {
        this.mensaje = data.mensaje
  }

  ngOnInit() { }

  closeDialog() {
    this.dialogRef.close({event: 2});
  }

  save(){
    this.dialogRef.close({event: 1});
  }

}